import { makeStyles } from '@material-ui/core/styles';
import { LayoutDirection } from 'features/app/ts/LayoutDirection';

export const useStyles = makeStyles(theme => ({
  slideContent: {
    flex: 1,
  },
  slideImage: {
    maxWidth: '550px',
    maxHeight: '321px',

    [theme.breakpoints.down('md')]: {
      width: '80%',
      paddingTop: theme.spacing(10),
      height: 'auto',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      height: 'auto',
      maxWidth: '313px',
      maxHeight: '181px',
    },
  },
  textContainer: {
    height: 'auto !important',
    padding: theme.spacing(38, 10),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(24, 6, 6),
    },
  },
  title: {
    fontSize: theme.spacing(12),
    fontWeight: 300,
    lineHeight: '32px',
    letterSpacing: '-0.67px',
    paddingBottom: theme.spacing(8),
  },
  subtitle: {
    maxWidth: theme.spacing(167.5),
    fontSize: ({ direction }: LayoutDirection) => direction === 'rtl' ? theme.spacing(12) : theme.spacing(8),
    // fontSize: theme.spacing(8),
    fontWeight: 300,
    lineHeight: '22px',
  },
}));
